var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirmwareUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26316 1H13.7368C14.4316 1 15 1.56842 15 2.26316V11.7368C15 12.4316 14.4316 13 13.7368 13H4.26316C3.56842 13 3 12.4316 3 11.7368V2.26316C3 1.56842 3.56842 1 4.26316 1Z",
    stroke: "#DD3302",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.875H3",
    stroke: "#DD3302",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.07501H3",
    stroke: "#DD3302",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.675H3",
    stroke: "#DD3302",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.875H18",
    stroke: "#DD3302",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.07501H18",
    stroke: "#DD3302",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.675H18",
    stroke: "#DD3302",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04675 3.8853C8.05277 3.39462 8.45226 3 8.94298 3C9.44228 3 9.84533 3.40802 9.8392 3.90728L9.80358 6.81141C9.79756 7.30209 9.39807 7.69671 8.90735 7.69671C8.40805 7.69671 8.00501 7.28869 8.01113 6.78942L8.04675 3.8853Z",
    fill: "#DD3302"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.59308,
    width: 1.79272,
    height: 1.79272,
    rx: 0.896359,
    fill: "#DD3302"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmwareUpdate);
export default __webpack_public_path__ + "static/media/Firmware_Update.4666917d15827ba2ad18a2d84641e7a4.svg";
export { ForwardRef as ReactComponent };